import { TranslateService } from '@ngx-translate/core/src/translate.service';
import { SelectItem } from 'primeng/components/common/api';

export class AcmType {
  id?: string;
  description: string;
  flg_operation: string;
  acm_type_code: number;
  acm_typei_pid: number;
  acm_typeo_pid: number;
}

/**
 * AcmTypeOperation contains SelectItem[] of flg_operation field of AcmType.
 */
export class AcmTypeOperation {

  private selectItems: SelectItem[];

  constructor (
    private translate: TranslateService) {

      this.translate.get([
        'acm_type.flg_operation_a',
        'acm_type.flg_operation_m',
        'acm_type.flg_operation_g'
      ]).subscribe((translations) => {
        this.selectItems = [
          { label: '', value: '' },
          { label: translations['acm_type.flg_operation_g'], value: 'G' },
          { label: translations['acm_type.flg_operation_m'], value: 'M' },
          { label: translations['acm_type.flg_operation_a'], value: 'A' }
        ];
      });
    }

  public getOptions() {
    return this.selectItems;
  }

}

export class AcmTypehasReason {
  id?: number;
  reason_id?: number;
  acm_type_id?: number;
  grant_role_id?: number;
  reasonCode?: string;
  reasonDescription?: string;
  short_description?: string;
  reasonType_pid?: any;
  reasonSign_pid?: any;
  acm_typei_pid?: number;
  acm_typeo_pid?: number;
}



// WEBPACK FOOTER //
// ./src/app/models/loyalty-acm-type.model.ts